// extracted by mini-css-extract-plugin
export default {"Toast":"SByHZ52qtm5ee6DWEHBT","ToastBox":"ryu8a6ACKcdfDUECw08w","ToastImage":"lSehHhLpkvHxIFhEd1m9","ToastText":"Eged8MXushzGY1lJEC52","Toast__Sucess":"Yq8_ttYuJCc3MLxst254","Toast__Error":"uu_PqaF2xx1rb0l0fqZj"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"Toast\":\"SByHZ52qtm5ee6DWEHBT\",\"ToastBox\":\"ryu8a6ACKcdfDUECw08w\",\"ToastImage\":\"lSehHhLpkvHxIFhEd1m9\",\"ToastText\":\"Eged8MXushzGY1lJEC52\",\"Toast__Sucess\":\"Yq8_ttYuJCc3MLxst254\",\"Toast__Error\":\"uu_PqaF2xx1rb0l0fqZj\"}";
        // 1779800064536
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  